import { PaginationQueryParams } from './pagination-query-params'

export type ArticleSort =
  | 'created_at_asc'
  | 'created_at_desc'
  | 'price_tag_asc'
  | 'price_tag_desc'
  | 'published_at_asc'
  | 'published_at_desc'

export type ArticleTemplate = 'inspiration' | 'planning'

export enum ArticleStatus {
  PUBLISHED = 'PUBLISHED',
  SCHEDULED = 'SCHEDULED',
  DRAFTED = 'DRAFTED',
  REDIRECTED = 'REDIRECTED',
}

export interface ArticlesAdminQueryParams extends PaginationQueryParams {
  search: string
  status: ArticleStatus[]
}
